import type { AddressInputVariableInterface } from '@corratech/pylot-address-book/src/hooks/use-create-address'
import { CountryCodeEnum } from '@pylot-data/enums/CountryCodeEnum'

export type SignUpAddressState = {
    firstName: string
    lastName: string
    saveAddressAs: string
    address: string
    addressNumber: string
    addressComplement: string
    zipcode: string
    addressPhone: string
    region: { name: string; id: string; code: string }
    comuna: { name: string; id: string }
}

export function toSignUpAddressInput(
    state: SignUpAddressState,
    document_number: string,
    phoneCode: string,
    countryCode: string
): AddressInputVariableInterface {
    // Magento admite 3 líneas: calle, número y depto.
    const street = [state.address, state.addressNumber, state.addressComplement]

    return {
        firstname: state.firstName,
        lastname: state.lastName,
        company: state.saveAddressAs,
        telephone: state.addressPhone,
        'street[0]': state.address,
        'street[1]': state.addressNumber,
        'street[2]': state.addressComplement,
        street,
        city: state.comuna.name,
        region: state.region.code,
        region_id: Number(state.region.id),
        comuna: state.comuna.name,
        comuna_id: state.comuna.id,
        prefix_phone: phoneCode,
        postcode: state.zipcode,
        country_code: countryCode as CountryCodeEnum,
        default_billing: true,
        default_shipping: true,
        save_in_address_book: true,
        document_number
    }
}
